












import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class DashboardSpecBox extends Vue {
  @Prop({required: true}) public mood!: string;
  @Prop({required: true}) public title!: string;
  @Prop({required: true}) public value!: number;

  get classNameByMood() {
    return `fill-${this.mood}`;
  }

}
